import { z } from "zod";

export const PolaritySchema = z.enum(["positive", "negative", "either"]);
export type Polarity = z.infer<typeof PolaritySchema>;

export const MonitorModeSchema = z.enum(["specific_event", "standing_watch"]);
export type MonitorMode = z.infer<typeof MonitorModeSchema>;

export const TimeWindowSchema = z.object({
  kind: z.enum(["absolute", "during_event"]),
  start: z.string().nullable().optional(),
  end: z.string().nullable().optional(),
  anchor: z.string().nullable().optional(),
});
export type TimeWindow = z.infer<typeof TimeWindowSchema>;

export const MonitorIRSchema = z.object({
  mode: MonitorModeSchema,
  required_entities: z.array(z.string()).default([]),
  action_class: z.string().default(""),
  polarity: PolaritySchema.default("either"),
  time_window: TimeWindowSchema.nullable().optional(),
  must_include_terms: z.array(z.string()).default([]),
  must_exclude_terms: z.array(z.string()).default([]),
  category_hints: z.array(z.string()).default([]),
  material_hints: z.array(z.string()).default([]),
  rationale: z.string().default(""),
});
export type MonitorIR = z.infer<typeof MonitorIRSchema>;

/** Stages of a monitor_match row. */
export const MatchStageSchema = z.enum(["candidate", "confirmed", "rejected"]);
export type MatchStage = z.infer<typeof MatchStageSchema>;

/** Allowed monitor lifecycle statuses. */
export const MonitorStatusSchema = z.enum(["active", "paused", "archived"]);
export type MonitorStatus = z.infer<typeof MonitorStatusSchema>;
